module.exports = __webpack_public_path__ + "static/media/ai-banner-avatar-2.b017f52c.webp";